/* tslint:disable */
/* eslint-disable */
export enum WorkMontageplanBacklogTypeEnum {
  All = 'all',
  Project = 'project',
  Task = 'task'
}
